import React from 'react'
import { Option } from 't3-widgets'
import { MobileNativeOption } from '../../../../../../../../common/components/mobile-native-select/mobile-native-option'

const FUEL_TYPE_STRINGCODE_PREFIX = 'ap_step3_fueltype_'

const getAppropriateSelect = (isMobile, props, caption) => {
    return isMobile ? (
        <MobileNativeOption {...props}>{caption}</MobileNativeOption>
    ) : (
        <Option {...props}>{caption}</Option>
    )
}

const brandsOptionsMapper = (brands, isMobile) => {
    const items = []

    brands.forEach(b => {
        const props = {
            key: `brand-option-${b.brandId}`,
            value: b.brandId
        }
        items.push(getAppropriateSelect(isMobile, props, b.brandName))
    })

    return items
}

const modelsOptionsMapper = (models, isMobile) => {
    const items = []

    models.forEach(m => {
        const props = {
            key: `model-option-${m.modelId}`,
            value: m.modelId
        }
        items.push(getAppropriateSelect(isMobile, props, m.modelName))
    })

    return items
}

const getTranslatedOrRAW = (rawFuelType, intl) => {
    const translated = intl.translate(FUEL_TYPE_STRINGCODE_PREFIX + rawFuelType.toLowerCase())

    return translated.includes(`#${FUEL_TYPE_STRINGCODE_PREFIX}`) ? rawFuelType : translated
}

const fuelTypeOptionsMapper = (ft, intl, isMobile) => {
    const items = []

    ft.forEach((ft, index) => {
        const props = {
            key: `fueltype-option-${index}`,
            value: index
        }
        items.push(getAppropriateSelect(isMobile, props, getTranslatedOrRAW(ft.fuelType, intl)))
    })

    return items
}

const getSelectedFuelType = (ft, ftIndex) => {
    return ft.map(ft => ft.fuelType)[ftIndex]
}

const generationOptionsMapper = (ftGroup, ftIndex, intl, isMobile) => {
    const yearsSortFunction = (ftgA, ftgB) => ftgA.yearFrom - ftgB.yearFrom
    const items = []

    if (ftIndex !== -1) {
        ftGroup.sort(yearsSortFunction).forEach((ftg, index) => {
            const props = {
                key: `generation-option-${index}`,
                value: ftg.generationNo
            }

            // eslint-disable-next-line max-len
            items.push(
                getAppropriateSelect(
                    isMobile,
                    props,
                    ftg.yearFrom +
                        ' - ' +
                        (ftg.yearTo === 'null' ? intl.translate('ap_step3_generation_today') : ftg.yearTo)
                )
            )
        })
    }

    return items
}

export { brandsOptionsMapper, modelsOptionsMapper, fuelTypeOptionsMapper, getSelectedFuelType, generationOptionsMapper }
